module.exports = __webpack_public_path__ + "img/result-btn_txt.09626b57.png";